import { useEffect, lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ContentProvider } from "@/context/ContentContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

const Home = lazy(() => import("@/pages/Home"));
const About = lazy(() => import("@/pages/About"));
const Music = lazy(() => import("@/pages/Music"));
const Videos = lazy(() => import("@/pages/Videos"));
const News = lazy(() => import("@/pages/News"));
const Events = lazy(() => import("@/pages/Events"));
const MVNNation = lazy(() => import("@/pages/MVNNation"));
const EPK = lazy(() => import("@/pages/EPK"));
const Booking = lazy(() => import("@/pages/Booking"));
const Contact = lazy(() => import("@/pages/Contact"));
const Privacy = lazy(() => import("@/pages/Privacy"));
const CookiePolicy = lazy(() => import("@/pages/CookiePolicy"));
const Admin = lazy(() => import("@/pages/Admin"));

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
};

const RouteFallback = () => (
  <div className="min-h-screen grid place-items-center bg-[#050505]" role="status" aria-label="Loading">
    <div className="h-8 w-8 rounded-full border-2 border-amberwarm/30 border-t-amberwarm animate-spin" />
  </div>
);

const PublicLayout = ({ children }) => (
  <>
    <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[200] focus:rounded-full focus:bg-amberwarm focus:px-5 focus:py-2 focus:text-sm focus:font-semibold focus:text-black">Skip to content</a>
    <Navbar />
    <main id="main-content">{children}</main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/admin" element={<Admin />} />
            <Route path="/" element={<ContentProvider><PublicLayout><Home /></PublicLayout></ContentProvider>} />
            <Route path="/about" element={<ContentProvider><PublicLayout><About /></PublicLayout></ContentProvider>} />
            <Route path="/music" element={<ContentProvider><PublicLayout><Music /></PublicLayout></ContentProvider>} />
            <Route path="/videos" element={<ContentProvider><PublicLayout><Videos /></PublicLayout></ContentProvider>} />
            <Route path="/news" element={<ContentProvider><PublicLayout><News /></PublicLayout></ContentProvider>} />
            <Route path="/events" element={<ContentProvider><PublicLayout><Events /></PublicLayout></ContentProvider>} />
            <Route path="/mvn-nation" element={<ContentProvider><PublicLayout><MVNNation /></PublicLayout></ContentProvider>} />
            <Route path="/epk" element={<ContentProvider><PublicLayout><EPK /></PublicLayout></ContentProvider>} />
            <Route path="/booking" element={<ContentProvider><PublicLayout><Booking /></PublicLayout></ContentProvider>} />
            <Route path="/contact" element={<ContentProvider><PublicLayout><Contact /></PublicLayout></ContentProvider>} />
            <Route path="/privacy" element={<ContentProvider><PublicLayout><Privacy /></PublicLayout></ContentProvider>} />
            <Route path="/cookies" element={<ContentProvider><PublicLayout><CookiePolicy /></PublicLayout></ContentProvider>} />
          </Routes>
        </Suspense>
        <Toaster position="top-center" theme="dark" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
